module.exports = {"622922100":"附城镇","622922101":"苏集镇","622922102":"胭脂镇","622922103":"景古镇","622922104":"莲麓镇","622922200":"康丰乡","622922201":"虎关乡","622922202":"流川乡","622922203":"白王乡","622922205":"八松乡","622922206":"鸣鹿乡","622922207":"八丹乡","622922208":"上湾乡","622922211":"草滩乡","622922212":"五户乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/622922.json
// module id = 2965
// module chunks = 0